<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';

interface AppFadeTransitionProps {
  animationTime?: 'medium' | 'long';
}

const props = withDefaults(defineProps<AppFadeTransitionProps>(), {
  animationTime: 'long',
});

const transitionName = computed(() => `fade-transition-${props.animationTime}`);

const isVisible = ref<boolean>(false);

onMounted(() => {
  isVisible.value = true;
});
</script>

<template>
  <Transition :name="transitionName">
    <slot v-if="isVisible" />
  </Transition>
</template>

<style scoped lang="scss">
@import '../../../styles/_media.scss';
@include for-less-or-equal-than-1200-px {
  .fade-transition-long-enter-active,
  .fade-transition-long-leave-active {
    transition: opacity var(--transition-long);
  }
  .fade-transition-long-enter-from,
  .fade-transition-long-leave-to {
    opacity: 0;
  }
}
.fade-transition-long-enter-active,
.fade-transition-long-leave-active {
  transition: opacity var(--transition-time-medium) ease-out
    var(--transition-time-medium);
}
.fade-transition-long-enter-from,
.fade-transition-long-leave-to {
  opacity: 0;
}

.fade-transition-medium-enter-active,
.fade-transition-medium-leave-active {
  transition: opacity var(--transition-medium);
}
.fade-transition-medium-enter-from,
.fade-transition-medium-leave-to {
  opacity: 0;
}
</style>
